export const normalizeCreateModalPayload = (payload) => {
  const hasNormalizedShape = payload && (
    payload.employeeName !== undefined
    || payload.employeeEmail !== undefined
    || payload.jobProfile !== undefined
  );

  if (hasNormalizedShape) {
    return {
      employeeName: payload.employeeName || '',
      employeeEmail: payload.employeeEmail || '',
      jobProfile: payload.jobProfile || '',
      employeeUlid: payload.employeeUlid,
      job_profile_ulid: payload.job_profile_ulid,
    };
  }

  if (!payload) {
    return {
      employeeName: '',
      employeeEmail: '',
      jobProfile: '',
      employeeUlid: undefined,
      job_profile_ulid: undefined,
    };
  }

  const name = [payload.first_name, payload.last_name].filter(Boolean).join(' ');

  return {
    employeeName: name,
    employeeEmail: payload.email || '',
    jobProfile: payload.job_profile_title || '',
    employeeUlid: payload.ulid,
    job_profile_ulid: payload.job_profile_ulid,
  };
};
